import { useNavigate } from 'react-router-dom';
import type { WidgetProps } from './registry';
import { decodeWidgetData } from './decode-widget-data';

type Decision = { prospectId: string; question: string; requestedAt: string };

// H.2.4: /outreach/prospects/:id retired — prospect links now scope the chat.
function ProspectBtn({ prospectId }: { prospectId: string }) {
  const navigate = useNavigate();
  return (
    <button
      type="button"
      className="text-sm font-medium hover:underline text-left"
      onClick={() => {
        sessionStorage.setItem('outreach-scope', JSON.stringify({ prospectId }));
        navigate('/outreach');
      }}
    >
      {prospectId}
    </button>
  );
}

export function InboxDecisions(props: WidgetProps) {
  const decisions = (decodeWidgetData(props.payload).decisions ?? []) as Decision[];

  if (decisions.length === 0) {
    return <p className="text-sm text-foreground-mute">No decisions awaiting you. ✓</p>;
  }

  return (
    <ul className="space-y-2">
      {decisions.map((d, i) => (
        <li key={`${d.prospectId}-${i}`} className="rounded border border-border p-3">
          <ProspectBtn prospectId={d.prospectId} />
          <p className="mt-1 text-sm">{d.question}</p>
          <p className="mt-1 text-[10px] text-foreground-mute">{d.requestedAt}</p>
        </li>
      ))}
    </ul>
  );
}
